var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Content", "../Configuration/VirtualScreen"], function (require, exports, Content_1, VirtualScreen_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MultiScreen = (function (_super) {
        __extends(MultiScreen, _super);
        function MultiScreen() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Layers = [];
            _this.Type = Content_1.ContentTypes.MultiScreen;
            _this.Parent = new VirtualScreen_1.VirtualScreen();
            return _this;
        }
        Object.defineProperty(MultiScreen.prototype, "IsMultiScreen", {
            get: function () { return true; },
            enumerable: true,
            configurable: true
        });
        return MultiScreen;
    }(Content_1.Content));
    exports.MultiScreen = MultiScreen;
});
//# sourceMappingURL=MultiScreen.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/MultiScreen.js
// module id = 146
// module chunks = 0